import { Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges } from '@angular/core';
import * as imageData from './imageDirTree.json';
import { NbDialogRef } from '@nebular/theme';
import { Section } from '../../editor-container/editor-model';
import { PreviewEditStoreService } from '../../services/preview-edit-store.service';
import { Subject, Subscription } from 'rxjs';
import { ContentElement, ContentElementEnum, ContentEnum, GridCell } from '@urbannex/storethemes';
import { takeUntil } from 'rxjs/operators';
import { CellEditorStoreService, LastActionEnum } from '../cell-editor-store.service';
import { OrientationEnum } from '@urbannex/storethemes';


@Component({
  selector: 'kve-sample-image-directory',
  templateUrl: './sample-image-directory.component.html',
  styleUrls: ['./sample-image-directory.component.scss']
})
export class SampleImageDirectoryComponent implements OnInit, OnChanges {
  @Input() title: string;
  /**
   * Target can be be section,cell,content
   */
  @Input() target: string;
  @Input() section: Section;
  @Input() contentEnum: ContentEnum;
  @Input() elId: string;
  /**
   * Service is either sectionEditorStoreService or cellEditorStoreService
   */
  @Input() service: string;
  /**
   * Property is either image or background-image
   */
  @Input() property: string

  selectedCell$: Subscription;
  selectedContent: ContentElement;

  @Input() dialogWidth: number;
  @Input() tabbed: boolean;
  @Input() isBackground: boolean;

  selectedCell: GridCell;
  /**
   * Currently selected or used image
   */
  imgSrc: string;
  cellId: string;
  // imgSrc$:Subscription;

  imageData: any;
  topLevelDirectories: any[];
  items: any[];
  depthLevel: number = 1;
  selectedItem: string;

  imageOrientation: OrientationEnum;

  selectedImageWidth: number;
  selectedImageHeight: number;
  newImgSrc: string;
  newImageOrientation: string;
  newImageWidth: number;
  newImageHeight: number;

  isSelected = false;
  isChosen = false;
  imageCompatibility = false;

  imageObjects: any[];
  destroy$ = new Subject<void>();

  @Output() setImageSrc: EventEmitter<string> = new EventEmitter<string>();


  constructor(
    protected ref: NbDialogRef<SampleImageDirectoryComponent>,
    private cellEditorStoreService: CellEditorStoreService,
    private previewEditStoreService: PreviewEditStoreService
  ) { }

  ngOnInit(): void {
    console.log(this.target);
    console.log(this.service);
    console.log(this.property)
    this.imageData = imageData;
    this.topLevelDirectories = this.imageData.children.filter(child => child["type"] == "directory");
    this.items = this.topLevelDirectories;
    this.selectedItem = this.items[0].name;
    // console.log(this.items);
    this.imageObjects = this.imageData.children[0].children;
    // console.log(this.imageObjects);
    this.selectedCell$ = this.cellEditorStoreService.selectedCell$.subscribe((selectedCell: GridCell) => {
      if (selectedCell != null && selectedCell != undefined) {
        this.selectedCell = selectedCell;
        this.cellId = selectedCell.cellId;
        if (this.selectedCell.contentEnum != undefined) {
          this.contentEnum = this.selectedCell.contentEnum;
        }
      }
    })
    console.log(this.cellId);
    console.log(this.selectedCell);
    console.log(this.tabbed)
    // Set the current image
    if (this.service == undefined) {
      this.service = "cellEditorStoreService"
    }
    switch (this.service) {
      case "cellEditorStoreService":
        if (this.target && (this.target == "self" || this.target == "cell")) {
          if (this.property == "background-image" && this.selectedCell.bgImgSrc) {
            this.imgSrc = this.selectedCell.bgImgSrc
          } else if (this.property == "background-image" && this.selectedCell.imgSrc) {
            this.imgSrc = this.selectedCell.imgSrc;
          }
        } else if (this.target && (this.target == "content" || this.target == "contentElement")) {
          this.cellEditorStoreService.activeSelector$.subscribe((selectedContent: ContentElement) => {
            this.selectedContent = selectedContent;
            if (selectedContent.imgSrc) {
              this.imgSrc = selectedContent.imgSrc;
            }
          })
        }
        /* this.selectedCell$ = this.cellEditorStoreService.selectedCell$.subscribe((selectedCell:GridCell) => {
          if(selectedCell != null && selectedCell != undefined){
            this.selectedCell = selectedCell;
            this.cellId = selectedCell.cellId;
            if(this.selectedCell.contentEnum != undefined){
              this.contentEnum = this.selectedCell.contentEnum;
            }
            if(this.contentEnum == ContentEnum.GALLERY || this.contentEnum == ContentEnum.HERO_IMAGE || this.target == 'contentElement'){
              this.cellEditorStoreService.activeSelector$.subscribe((selectedContent:ContentElement) => {
                this.selectedContent = selectedContent;
                if(selectedContent.imgSrc){
                  this.imgSrc = selectedContent.imgSrc;
                }
              })

            }else{
              console.log(this.selectedCell);
              this.imgSrc = this.selectedCell.imgSrc;
            }

          }
        }) */
        break;
      case "sectionEditorStoreService":

        break;

      default:
        break;
    }


    /* this.selectedCell$ = this.previewEditStoreService.selectedCell$.pipe(takeUntil(this.destroy$))
    .subscribe(data => {
      console.log(data);
      data = this.selectedCell;
    }) */

  }
  selectItem(e: number) {
    console.log(e);
    // console.log({index:index,type:type,depthLevel:this.depthLevel})
    this.imageObjects = this.imageData.children[e].children;
    /* if(type == "directory"){
      switch (this.depthLevel) {
        case 1:
          this.items = this.items[index].children;
          break;
        case 2:
          console.log(this.items);
          this.items = this.items["children"][index].children;
          break
        case 3:
          this.items = this.items["children"]["children"][index].children;
        default:
          break;
      }
      this.depthLevel += 1;
    }else{

    } */
  }

  ngOnChanges(changes: SimpleChanges) {
    /* if(changes["cellId"]){
      console.log(this.cellId);
      console.log(this.section);
    } */
    /* if(changes["imgSrc"]){
      let sharpImage = sharp(this.imgSrc);
      sharpImage.metadata().then(data => {
        console.log(data.orientation)
        console.log(data.width)
        console.log(data.height)
      })
    } */
  }

  selectImage(e) {
    const el = <HTMLImageElement>e.srcElement;
    const imgSrc = e.target.currentSrc;
    this.newImageHeight = el.naturalHeight;
    this.newImageWidth = el.naturalWidth;
    if (this.newImageWidth > this.newImageHeight) {
      this.newImageOrientation = "landscape";
    } else {
      this.newImageOrientation = "portrait";
    }
    console.log(this.newImageOrientation);
    // console.log({Height:el.naturalHeight,Width:el.naturalWidth,src:imgSrc});
    this.newImgSrc = imgSrc;
    this.isSelected = true;
    this.isChosen = false;
    this.compareImages()
  }

  compareImages() {
    if (this.section != undefined) {
      console.log(this.section);
      const sectionData = this.section.sectionData;
      const width = sectionData.width ? sectionData.width : this.selectedCell.width;
      const height = sectionData.height ? sectionData.height : this.selectedCell.height;
      const imageOrientation = sectionData.imageOrientation ? sectionData.imageOrientation : this.selectedCell.imageOrientation
      // const imageAspectRatio = this.selectedCell.width/this.selectedCell.height;
      const imageAspectRatio = width / height;
      console.log(imageAspectRatio);
      const newAspectRation = this.newImageWidth / this.newImageHeight;
      console.log(newAspectRation);
      const aspectRatioDiff = imageAspectRatio - newAspectRation;
      const widthScale = width / this.newImageWidth;
      if (imageOrientation == this.newImageOrientation && (aspectRatioDiff < 0.8 || aspectRatioDiff > -0.8) && widthScale < 1.2) {
        this.imageCompatibility = true;
      } else {
        this.imageCompatibility = false;
      }
    }

  }
  /**
   *
   * @param mode Selectes which componentStore handles the selected image
   * Options are "editor" and "builder"
   * The "builder" option is used to select image for new cell
   * The "editor" option is used to update an existing image
   */
  onUseImage() {
    console.log(this.newImgSrc)
    this.imgSrc = this.newImgSrc;
    this.isChosen = true;

    this.cellEditorStoreService.updateImageChosen(true);
    if (this.contentEnum != undefined && this.contentEnum == ContentEnum.GALLERY || this.contentEnum == ContentEnum.HERO_IMAGE || this.target == "contentElement") {
      // Update contentElement image
      const selectedContEl = this.selectedCell.contentElements.find(contentEl => contentEl.elId == this.elId);
      if (selectedContEl != undefined) {
        selectedContEl.imgSrc = this.imgSrc;
        this.cellEditorStoreService.updateActiveSelector(selectedContEl);
      } else {
        console.log("contentEnum is undefined")
        if (this.contentEnum == ContentEnum.HERO_IMAGE) {
          console.log("It's a Hero Image")
          const imageCell = this.selectedCell.contentElements.find(element => element.contentElementEnum == ContentElementEnum.IMAGE);
          if (imageCell != undefined) {
            imageCell.imgSrc = this.imgSrc;
            this.cellEditorStoreService.updateActiveSelector(imageCell);
          } else {
            console.log("Image Cell Not found")
          }

        }
      }
      console.log("cell-editor-store.service.ts - updating selected cell img: " + this.imgSrc);
      this.cellEditorStoreService.updateSelectedCellImgSrc(this.imgSrc);
      // this.cellEditorStoreService.updateImgSrc(this.imgSrc);
    } else {
      // Update non-contentElement image
      console.log("Updating Cell Image");
      this.cellEditorStoreService.updateImgSrc(this.imgSrc);
      if (this.isBackground) {
        this.setImageSrc.emit(this.imgSrc);
      } else {
        this.cellEditorStoreService.updateLastActionState(LastActionEnum.IMAGE_SET);
      }
    }



  }

  onUseExistingImage() {
    this.cellEditorStoreService.updateLastActionState(LastActionEnum.IMAGE_SET);
  }

  onSaveImage() {
    console.log("Murife don't run");
    if (this.selectedContent != undefined) {
      this.selectedContent.imgSrc = this.imgSrc;
    } else {
      this.selectedCell.imgSrc = this.imgSrc;
    }
    console.log(this.selectedCell);
    this.ref.close(this.selectedCell);
  }

  onUndo() {

  }

  onCancel() {

  }

  onFileSelected(e) {
    console.log(e);
  }


  close() {
    this.ref.close();
  }


}
